// extracted by mini-css-extract-plugin
export default {"productCarousel":"t7-z"};